//

import { normalize } from 'normalizr';
import moment from 'moment';

import { simplApi } from '../../api/simplApi';

import { objectNumber } from './schemas';
import { dateFormat } from '../../helpers/formats';
import { fetchTotalData } from './totaldata';
import handleApiError from '../../helpers/handleApiError';

const _ = require('lodash');

// ------------------------------------
// Constants
// ------------------------------------
export const REQUEST_OBJECTNUMBER = 'REQUEST_OBJECTNUMBER';
export const RECEIVE_OBJECTNUMBER = 'RECEIVE_OBJECTNUMBER';
export const SET_OBJECTNUMBER = 'SET_OBJECTNUMBER';
export const SET_OBJECTNUMBER_FORM = 'SET_OBJECTNUMBER_FORM';
export const CLOSE_OBJECTNUMBER_FORM = 'CLOSE_OBJECTNUMBER_FORM';
export const REMOVE_OBJECTNUMBER = 'REMOVE_OBJECTNUMBER';

// ------------------------------------
// Actions
// ------------------------------------

export function requestObjectNumber() {
  return {
    type: REQUEST_OBJECTNUMBER,
  };
}

export function receiveObjectNumber(objectNumbers) {
  return {
    type: RECEIVE_OBJECTNUMBER,
    payload: {
      objectNumbers,
    },
  };
}

export function setObjectNumber(objectNumberId) {
  // console.log('action setObjectNumber', objectNumberId);
  return {
    type: SET_OBJECTNUMBER,
    payload: objectNumberId,
  };
}

export function setObjectNumberForm(objectNumberId = '') {
  return {
    type: SET_OBJECTNUMBER_FORM,
    payload: objectNumberId,
  };
}

export function closeObjectNumberForm() {
  return {
    type: CLOSE_OBJECTNUMBER_FORM,
  };
}

export const fetchObjectNumber = objectNumberId => dispatch => {
  dispatch(requestObjectNumber());

  const url =
    typeof objectNumberId !== 'undefined' && objectNumberId !== null
      ? `objectNumber/${objectNumberId}`
      : 'objectNumber';

  simplApi(url)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }

        dispatch(handleApiError(json));
      } else {
        let preparedObjectNumbers;

        if (typeof json.objectNumbers !== 'undefined') {
          preparedObjectNumbers = normalize(json, {
            objectNumbers: [objectNumber],
          });
        } else {
          preparedObjectNumbers = normalize(json, {
            objectNumber,
          });
        }

        // // console.log('prepping comps', preparedObjectNumbers)

        dispatch(
          receiveObjectNumber(preparedObjectNumbers.entities.objectNumbers),
        );
      }
    });
};

export function removeObjectNumber(objectNumberId) {
  return {
    type: REMOVE_OBJECTNUMBER,
    payload: objectNumberId,
  };
}

export const deleteObjectNumber = objectNumberId => dispatch => {
  const url = `objectNumber/${objectNumberId}`;
  const options = { method: 'delete' };

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }
        dispatch(handleApiError(json));
      } else {
        dispatch(removeObjectNumber(objectNumberId));
      }
    });
};

export const saveObjectNumber = newObjectNumber => dispatch => {
  // console.log('attempting to save an objectNumber!');

  dispatch(requestObjectNumber());

  let url = 'objectNumber/';
  const options = { method: 'post', body: newObjectNumber };
  if (
    typeof newObjectNumber.id !== 'undefined' &&
    newObjectNumber.id !== null
  ) {
    url = `${url}${newObjectNumber.id}`;
    options.method = 'put';
  }

  simplApi(url, options)
    .then(data => data.json())
    .then(json => {
      if (typeof json.error !== 'undefined') {
        if (__DEV__) {
          // console.log('error!');
        }
        dispatch(handleApiError(json));
      } else {
        const preparedObjectNumbers = normalize(json, objectNumber);

        dispatch(
          receiveObjectNumber(preparedObjectNumbers.entities.objectNumbers),
        );
        dispatch(fetchTotalData());
      }
    });
};

export const actions = {
  requestObjectNumber,
  receiveObjectNumber,
  fetchObjectNumber,
  setObjectNumber,
  setObjectNumberForm,
  closeObjectNumberForm,
  saveObjectNumber,
  deleteObjectNumber,
  removeObjectNumber,
};

const OBJECTNUMBER_ACTION_HANDLERS = {
  [REQUEST_OBJECTNUMBER]: state => ({
    ...state,
    fetching: true,
  }),
  [SET_OBJECTNUMBER]: (state, action) => ({
    ...state,
    current: action.payload,
  }),
  [SET_OBJECTNUMBER_FORM]: (state, action) => ({
    ...state,
    formOpen: true,
    formTarget: action.payload,
  }),
  [REMOVE_OBJECTNUMBER]: (state, action) => ({
    ...state,
    objectNumbers: _.omit(state.objectNumbers, action.payload),
  }),
  [CLOSE_OBJECTNUMBER_FORM]: state => ({
    ...state,
    formOpen: false,
    formTarget: null,
  }),
  [RECEIVE_OBJECTNUMBER]: (state, action) => {
    const stateObjectNumbers = state.objectNumbers;

    _.forOwn(action.payload.objectNumbers, (_objectNumber, id) => {
      const newObjectNumber = _objectNumber;

      newObjectNumber.createdDate = moment(_objectNumber.created_at).format(
        dateFormat,
      );

      if (typeof stateObjectNumbers[id] === 'object') {
        Object.assign(
          stateObjectNumbers[id],
          stateObjectNumbers[id],
          newObjectNumber,
        );
      } else {
        stateObjectNumbers[id] = newObjectNumber;
      }
    });

    return {
      ...state,
      objectNumbers: stateObjectNumbers,
      fetching: false,
    };
  },
};

// ------------------------------------
// Reducer
// ------------------------------------

const initialState = {
  current: null,
  formOpen: false,
  formTarget: null,
  fetching: false,
  objectNumbers: {},
};
export default function objectNumberReducer(state = initialState, action) {
  const handler = OBJECTNUMBER_ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}



// WEBPACK FOOTER //
// ./src/store/modules/objectnumber.js